export default "__VITE_ASSET__RXUggR7___"